import axios from "axios"
import { BASE_URL } from "../Config/api"
import { CreateToken } from "../Components/Utilities/CreateToken"
import { removeAuthorizationHeader } from "../Config/axiosInterceptor"

export const checkLogin = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/login`,
            data: { token: CreateToken(data) }
        })

        return {
            status: "success",
            data: response.data
        }
    } catch (err) {
        if (err.response?.status === 401) {
            return {
                status: "failed",
                message: "Authentication failed: Incorrect Username / Password"
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status",
            message: err.message
        }
    }
}

export const changePass = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/changePassword`,
            data: { token: CreateToken(data) }
        })

        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        if (err.response?.status === 401) {
            return {
                status: "failed",
                message: "Authentication failed"
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status",
            message: err.message
        }
    }
}

export const checkAuth = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/checkAuth`,
            data: { token: CreateToken(data) }
        })
        return {
            status: "success",
            username: response.data.data.username,
            salaryedit: response.data.data.salaryedit,
            tier: response.data.data.tier,
            eid: response.data.data.eid
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const welcome = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/welcome`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchDropdownOptions = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchDropdownOptions`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const addDropdownOption = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/addDropdownOption`,
            data: { token: CreateToken(data) }
        })

        return {
            status: response.data.status,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const addEmp = async (data, fileData) => {
    let formData = new FormData()

    formData.append('token', CreateToken(data))
    for (const key in fileData) {
        if (Array.isArray(fileData[key])) {
            fileData[key].forEach(file => {
                formData.append(key, file)
            })
        } else {
            formData.append(key, fileData[key])
        }
    }
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/addNewEmployee`,
            headers: { "Content-Type": "multipart/form-data" },
            data: formData
        })

        return {
            status: response.data.status,
            message: response.data.message,
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.error || err.response?.data?.message || err.message
        }
    }
}

export const empCheck = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/empCheck`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.error || err.response?.data?.message || err.message
        }
    }
}

export const fetchEmpPaySlipsCount = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpPaySlipsCount`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchAllEmployeeCounts = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchAllEmployeeCounts`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchAllEmployeeRecords = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchAllEmployeeRecords`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchNewEmpRecords = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchNewEmployeeRecords`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchActiveEmpCount = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchActiveEmployeeCounts`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        if (err.response?.status === 401) {
            // logout()
            return {
                status: "failed",
                message: "Session expired"
            }
        }
        return {
            status: "failed"
        }
    }
}

export const fetchActiveEmpRecords = async (data, logout) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchActiveEmployeeRecords`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        if (err.response?.status === 401) {
            await removeAuthorizationHeader()
            await logout()
            return {
                status: "failed",
                message: "Session expired"
            }
        }

        return {
            status: "failed"
        }
    }
}

export const fetchInactiveEmpCount = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchInactiveEmployeeCounts`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchInactiveEmpRecords = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchInactiveEmployeeRecords`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchDropoutEmployeeCounts = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchDropoutEmployeeCounts`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchDropoutEmployeeRecords = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchDropoutEmployeeRecords`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const checkEmpUnderManager = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/checkEmpUnderManager`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchTotalEmp = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchTotalEmp`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {

        return {
            status: "failed"
        }
    }
}

export const fetchNewMonthlyHires = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchNewMonthlyHires`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {

        return {
            status: "failed"
        }
    }
}

export const fetchPendingChanges = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchPendingChanges`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {

        return {
            status: "failed"
        }
    }
}

export const updatePendingChanges = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/updatePendingChanges`,
            data: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {

        return {
            status: "failed"
        }
    }
}

export const activeEmp = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/activeEmp`,
            data: { token: CreateToken(data) }
        })

        return {
            status: response.data.status,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const rejectEmp = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/rejectEmp`,
            data: { token: CreateToken(data) }
        })

        return {
            status: response.data.status,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const terminateEmp = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/terminateEmp`,
            data: { token: CreateToken(data) }
        })

        return {
            status: response.data.status,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const markEmpAsAbsconded = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/markEmpAsAbsconded`,
            data: { token: CreateToken(data) }
        })

        return {
            status: response.data.status,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const revokeTermination = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/revokeTermination`,
            data: { token: CreateToken(data) }
        })

        return {
            status: response.data.status,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmpPersonalDetails = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpPersonalDetails`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {

        return {
            status: "failed"
        }
    }
}

export const fetchEmpDetails = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpDetails`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmpJoiningDetails = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpJoiningDetails`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmpVisaDetails = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpVisaDetails`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmpContactDetails = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpContactDetails`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmpSalaryDetails = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpSalaryDetails`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmpDocumentDetails = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpDocumentDetails`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
            docs: response.data.docs
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmpContractDetails = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpContractDetails`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {

        return {
            status: "failed"
        }
    }
}

export const fetchSingleEmpRecord = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchSingleEmpRecord`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
            docs: response.data.docs
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const updateEmpRecords = async (data, fileData) => {
    let formData = new FormData()

    formData.append('token', CreateToken(data))
    for (const key in fileData) {
        if (Array.isArray(fileData[key])) {
            fileData[key].forEach(file => {
                formData.append(key, file)
            })
        } else {
            formData.append(key, fileData[key])
        }
    }

    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/updateEmpRecords`,
            headers: { 'Content-Type': 'multipart/form-data' },
            data: formData
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const checkEmpExist = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/checkEmpExist`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
            employee: response.data.employee,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const deleteDocs = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/deleteDocs`,
            data: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmployeesForLeaveApplication = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmployeesForLeaveApplication`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchExistingLeaveBalance = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchExistingLeaveBalance`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const submitLeaveApplication = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/submitLeaveApplication`,
            data: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            message: response.data.message
        }
    } catch (err) {
        if (err.response?.status === 401) {

        }
        if (err.response?.status === 400) {
            return {
                status: err.response.data.status,
                error: err.response.data.message
            }
        }
        return {
            status: "failed",
            error: "Failed to submit leave application. (Contact Administrator)"
        }
    }
}

export const fetchLeaveApplicationCounts = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchLeaveApplicationCounts`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        if (err.response?.status === 401) {
            // logout()
            return {
                status: "failed",
                message: "Session expired"
            }
        }
        return {
            status: "failed"
        }
    }
}

export const fetchLeaveApplications = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchLeaveApplications`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const changeLeaveStatus = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/changeLeaveStatus`,
            data: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.message
        }
    }
}

export const skipPendingApprover = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/skipPendingApprover`,
            data: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.message
        }
    }
}

export const changeEndDate = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/changeEndDate`,
            data: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.message
        }
    }
}

export const fetchLeaveHistoryCount = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchLeaveHistoryCount`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        if (err.response?.status === 401) {
            // logout()
            return {
                status: "failed",
                message: "Session expired"
            }
        }
        return {
            status: "failed"
        }
    }
}

export const fetchLeaveHistory = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchLeaveHistory`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            message: err.message
        }
    }
}

export const cancelLeave = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/cancelLeave`,
            data: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchLineManager = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchLineManager`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchTrackHistory = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchTrackHistory`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmployeesUnderManager = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmployeesUnderManager`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmpsUnderManagersCount = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpsUnderManagersCount`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchTrackLeaves = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchTrackLeaves`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchSalaryCertifHistory = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchSalaryCertifHistory`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const applySalaryCert = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/applySalaryCert`,
            data: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.message
        }
    }
}

export const fetchEmployeesForSalaryCertificate = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmployeesForSalaryCertificate`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchSalaryCertificatesCounts = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchSalaryCertificatesCounts`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        if (err.response?.status === 401) {
            // logout()
            return {
                status: "failed",
                message: "Session expired"
            }
        }
        return {
            status: "failed"
        }
    }
}

export const fetchSalaryCertificates = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchSalaryCertificates`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const handleSalaryCert = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/handleSalaryCert`,
            data: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.message
        }
    }
}

export const fetchEmpSalaryCertificates = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpSalaryCertificates`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const skipPendingSalaryApprover = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/skipPendingSalaryApprover`,
            data: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.message
        }
    }
}

export const cancelSalaryCertificateRequest = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/cancelSalaryCertificateRequest`,
            data: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const downloadSalaryCertificate = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/downloadSalaryCertificate`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmpPaySlips = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpPaySlips`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchNewEmpCount = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchNewEmployeeCounts`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const updateLWD = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${BASE_URL}/updateLWD`,
            data: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.message
        }
    }
}

//Reports

export const fetchEmployeeReports = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmployeeReports`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmpReportCount = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpReportCount`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchEmpReportFilterCount = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchEmpReportFilterCount`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const downloadEmployeeReports = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/downloadEmployeeReports`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchHistoryReports = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchHistoryReports`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchHistoryReportCount = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchHistoryReportCount`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const fetchLeaveReports = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchLeaveReports`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
            total: response.data.total,
            filters: response.data.filters
        }
    } catch (err) {
        console.error('Error fetching leave reports:', err);
        return {
            status: "failed",
            error: err.message
        }
    }
}

export const exportLeaveReports = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/exportLeaveReports`,
            params: { token: CreateToken(data) },
            responseType: 'blob'
        })

        const blob = new Blob([response.data], {
            type: 'text/csv; charset=utf-8'
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'leave-reports.csv');

        // Append to body, click, and remove
        document.body.appendChild(link);
        link.click();

        // Clean up
        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }, 100);

        return {
            status: "success",
            message: "Report exported successfully"
        }
    } catch (err) {
        console.error('Error exporting leave reports:', err);
        return {
            status: "failed",
            error: err.response?.data?.message || err.message || 'Export failed'
        }
    }
}

export const fetchLeaveBalanceReports = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchLeaveBalanceReports`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
            total: response.data.total,
            filters: response.data.filters
        }
    } catch (err) {
        console.error('Error fetching leave reports:', err);
        return {
            status: "failed",
            error: err.message
        }
    }
}

export const exportLeaveBalanceReports = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/exportLeaveBalanceReports`,
            params: { token: CreateToken(data) },
            responseType: 'blob'
        })

        const blob = new Blob([response.data], {
            type: 'text/csv; charset=utf-8'
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'leave-balance-reports.csv');

        // Append to body, click, and remove
        document.body.appendChild(link);
        link.click();

        // Clean up
        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }, 100);

        return {
            status: "success",
            message: "Leave balance report exported successfully"
        }
    } catch (err) {
        console.error('Error exporting leave balance reports:', err);
        return {
            status: "failed",
            error: err.response?.data?.message || err.message || 'Export failed'
        }
    }
}

//Dashboard
export const fetchExpiryDates = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/fetchExpiryDates`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
            counts: response.data.counts,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

//Inactive Employees
export const downloadExperienceLetter = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/downloadExperienceLetter`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}

export const downloadTerminationLetter = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}/downloadTerminationLetter`,
            params: { token: CreateToken(data) }
        })
        return {
            status: response.data.status,
            data: response.data.data,
        }
    } catch (err) {
        return {
            status: "failed"
        }
    }
}
// ---------------------------------------------------------------------------
// Activity Tracker
// These endpoints authenticate off the Bearer token the axios interceptor
// already attaches (tier 1/2 only), so there is no encrypted-token payload.
// ---------------------------------------------------------------------------

const trackerRequest = async (path, params) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${BASE_URL}${path}`,
            params: params
        })
        return {
            status: response.data.status,
            data: response.data.data,
            total: response.data.total
        }
    } catch (err) {
        return {
            status: "failed",
            message: err.response?.data?.error || "Could not load activity data"
        }
    }
}

export const fetchActivitySummary = async (date) =>
    trackerRequest('/tracker/api/summary', { date })

export const fetchActivityLogs = async (filters) =>
    trackerRequest('/tracker/api/logs', filters)

export const fetchActivityUsers = async (days) =>
    trackerRequest('/tracker/api/users', { days })

export const fetchActivityTrend = async (days) =>
    trackerRequest('/tracker/api/trend', { days })

// Ends the session server-side so the tracker records a real logout event.
export const logoutSession = async () => {
    try {
        await axios({ 'method': 'post', 'url': `${BASE_URL}/logout` })
        return { status: "success" }
    } catch (err) {
        // The user is signing out regardless — never block on this.
        return { status: "failed" }
    }
}
